/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa AJAX
 *
 * @export
 * @class AjaxTools
 * @extends {DataTools}
 */
import { DataTools } from "./DataTools.class";

export class AjaxTools extends DataTools {
	constructor(){
		super();
		this.ajaxLoadDataDefaultSettings = {
			url: null,
			cache: true,
			method: 'GET',
			dataType: 'html',
			updateBrowserHistory: true,
			forceAjaxPageLoad: false,
			eventPopstate: false,
			target: '#mainPage',
			loadingMode: true,
			loadingTarget: 'body',
			getDataMode: false,
			onBeforeSend: function () { },
			onBeforeSuccess: function () { },
			onError: function () {
			},
			onSuccess: function () { },
			onComplete: function () { },
			onStatusCode404: function (target) {
				if ($(target).length > 0) {
					$(target).load('/stat/page404?current_action=ajax');
				}
			},
			getData: function (data, target, dataType) {
				if (dataType == 'JSON')
					this.convertJSONData(data, target);
			}.bind(this),
			sourceOfError: 'AjaxTools::ajaxLoadData'
		};
		this.lastRequest = null;
		this.xhrActiveRequests = new Map(),
		this.preventSendingAnotherAjaxRequest = false;

		$(window).on('beforeunload', function(){
			this.abortAllActiveXhrRequests();
		}.bind(this));
	}
	// ****************************************************************************************************
	// inicjacja historii AJAXu ->>> przy załadowaniu strony
	// ****************************************************************************************************
	refreshAjaxHistory() {
		let that = this;

		let params = that.removeDisallowedParametersFromURL();

		history.replaceState({
			listingType: that.getCookie('productsListingStyle'),
			scroll: $(window).scrollTop()
		}, document.title, location.pathname + params + window.location.hash);
	}
	// ****************************************************************************************************
	// Dodanie nowego wpisu do tablicy historii AJAXu
	// ****************************************************************************************************
	addToAjaxHistory(newEntryUrl) {
		var that = this;
		history.pushState({
			listingType: that.getCookie('productsListingStyle'),
			scroll: 0 // $(window).scrollTop()
		}, document.title, that.removeDefaultParameters(newEntryUrl));
		$(window).scrollTop(0);
	}
	// ****************************************************************************************************
	// Ustawienie listingu po popstate z AJAX history (nie odejmuje indexu!!!!)
	// ****************************************************************************************************
	setListingTypeFromAjaxHistory(eventPopstate) {
		var that = this;
		var state = that.getDataFromPopstateEvent(eventPopstate);
		that.setCookie('productsListingStyle', state.listingType, 365);
	}
	// ****************************************************************************************************
	// inicjacja historii AJAXu ->>> przy załadowaniu strony
	// ****************************************************************************************************
	setScrollTopFromAjaxHistory(eventPopstate) {
		var that = this;
		var state = that.getDataFromPopstateEvent(eventPopstate);
		$(window).scrollTop(state.scroll);
	}
	// ****************************************************************************************************
	// pobranie danych (data) z eventu popstate
	// ****************************************************************************************************
	getDataFromPopstateEvent(eventPopstate) {
		return (eventPopstate.state) ? eventPopstate.state : eventPopstate.originalEvent.state; // data z browser history - generalnie trzeba tu zachować czujność, wszedzie było event.state a nie event.originalEvent.state
	}
	// ****************************************************************************************************
	// obsluga AJAX - pobieranie zawartosci strony
	// ****************************************************************************************************
	ajaxLoadData(options) {
		var that = this;
		//var currentUrl = location.pathname+location.search;
		var settings = $.extend({}, that.ajaxLoadDataDefaultSettings, options);
		settings.target = that.createUniqueRequestTarget(settings.target);
		//console.log('createUniqueRequestTarget',settings.target);
		if (settings.url !== null) {
			if (!that.preventSendingAnotherAjaxRequest || settings.forceAjaxPageLoad) {
				//console.log('ajaxLoadData',that.prepareAjaxUrl(settings.url));
				that.lastRequest = $.ajax({
					url: that.prepareAjaxUrl(settings.url),
					cache: settings.cache,
					method: settings.method,
					dataType: settings.dataType,
					beforeSend: function () {
						if ( !settings.eventPopstate ) {
							that.refreshAjaxHistory();
						}

						that.preventSendingAnotherAjaxRequest = true;
						if (settings.loadingMode) {
							that.addLoadingPanel(settings.loadingTarget);
						}
						settings.onBeforeSend.call();
						if (settings.eventPopstate) {
							that.setListingTypeFromAjaxHistory(settings.eventPopstate);
						}
					},
					success: function (data) {
						if ($(settings.target).length > 0) {
							that.preventSendingAnotherAjaxRequest = false;
							settings.onBeforeSuccess.call();
							if (!settings.eventPopstate && settings.updateBrowserHistory) {
								that.addToAjaxHistory(settings.url);
							}
							if (settings.getDataMode)
								settings.getData.call(this, data, settings.target, settings.dataType);
							else
								$(settings.target).html(data);
							settings.onSuccess.call();
						} else if ( that.xhrActiveRequests.has(settings.target) && that.xhrActiveRequests.get(settings.target).readyState == 4 ){ // jesli readyState == 4 == OK
							loggerObj.addCustomError('Wrong AJAX target -> '+settings.target+' -> readyState: '+that.xhrActiveRequests.get(settings.target).readyState, settings.sourceOfError);
						}
					},
					error: function (jqXHR, textStatus, errorThrown) {
						if ( that.xhrActiveRequests.has(settings.target) && that.xhrActiveRequests.get(settings.target).readyState == 4 ) { // jesli readyState == 4 == OK
							loggerObj.addCustomError('AJAX ERROR -> '+settings.target+' -> readyState: '+that.xhrActiveRequests.get(settings.target).readyState, settings.sourceOfError);
						}

						settings.onError.call();
					},
					statusCode: {
						404: function (data) {
							$(settings.target).html('');
							settings.onStatusCode404.call(this, settings.target);
						}
					},
					complete: function () {
						if ($(settings.target).length > 0) {
							if (settings.loadingMode) {
								that.removeLoadingPanel(settings.loadingTarget);
							}
							settings.onComplete.call();
							if ( settings.eventPopstate ) {
								that.setScrollTopFromAjaxHistory(settings.eventPopstate);
							}
						}
						that.xhrActiveRequests.delete(settings.target);
					}
				});

				that.xhrActiveRequests.set(settings.target, that.lastRequest);
				that.lastRequest = null;
			}
		} else {
			console.warn('Loading page failed. No url parameter.');
			loggerObj.addCustomError('Loading failed. No url parameter', 'AjaxTools::ajaxLoadData');
		}
	}
	// ****************************************************************************************************
	// utworzenie unikalnego celu dla Ajaxu  - umozliwa
	// ****************************************************************************************************
	createUniqueRequestTarget(target) {
		var that = this;
		var uniqId = Date.now();
		$(target).removeClass(function (index, className) {
			return (className.match(/uniq-id-request-([0-9])+/) || []).join(' ');
		}).addClass('uniq-id-request-' + uniqId);
		return target + '.uniq-id-request-' + uniqId;
	}
	// ****************************************************************************************************
	// przygotowanie adresu dla AJAXu
	// ****************************************************************************************************
	prepareAjaxUrl(url) {
		var that = this;
		if (url.includes('?')) {
			var urlSplit = url.split('?');
			if (urlSplit[1].includes('current_action=ajax')) {
				return urlSplit[0] + '?' + urlSplit[1];
			}
			else {
				return urlSplit[0] + '?' + urlSplit[1] + '&current_action=ajax';
			}
		}
		else {
			return url + '?current_action=ajax';
		}
	}
	// ****************************************************************************************************
	// wyświtlanie panelu ładowania (gif)
	// ****************************************************************************************************
	addLoadingPanel(target) {
		target = (target === undefined) ? 'body ' : target;
		if ($(target + ' .loading').length < 1) {
			$(target).prepend($('<div class="loading"><img class="verticallyCentred" src="/img/loading.gif"/></div>'));
			$(target + ' .loading').animate({
				opacity: 1
			}, EFFECTS_SPEED);
		}
	}
	// ****************************************************************************************************
	// wygaszanie panelu ładowania (gif)
	// ****************************************************************************************************
	removeLoadingPanel(target) {
		target = (target === undefined) ? 'body ' : '';
		$(target + '.loading').animate({
			opacity: 0
		}, EFFECTS_SPEED, function () {
			$(target + '.loading').remove();
		});
	}
	// ****************************************************************************************************
	// Domyślna fuknkjca wyświetlająca dane JSON
	// ****************************************************************************************************
	convertJSONData(data, target) {
		//console.log('convertJSONData', this, data, target);
		var that = this;
		var rootJSON;
		that.items = [];
		for (root in data) {
			rootJSON = root;
		}
		$("<p/>", {
			"class": "strong mb-0 p-5",
			html: '<b>' + rootJSON + '[0].id:</b> ' + data[rootJSON][0].id
		}).appendTo(target);
		that.basicDecodeJSONData(data);
		$("<ul/>", {
			"class": "my-new-list",
			html: that.items.join("")
		}).appendTo(target);
	}
	basicDecodeJSONData(data) {
		var that = this;
		$.each(data, function (key, val) {
			if (jQuery.type(val) === 'array') {
				that.items.push("<li><p class='mb-0'><b>" + key + "</b> (---> " + jQuery.type(val) + " <---)</p><ul>");
				that.basicDecodeJSONData(val);
				that.items.push("</li></ul>");
			}
			else if (jQuery.type(val) === 'object') {
				that.items.push("<li><p class='mb-0'><b>" + key + "</b> (---> " + jQuery.type(val) + " <---)</p><ul>");
				that.basicDecodeJSONData(val);
				that.items.push("</li></ul>");
			}
			else {
				that.items.push("<li><b>" + key + "</b>: " + val + " (---> " + jQuery.type(val) + " <---)</li>");
			}
		});
	}
	// ****************************************************************************************************
	// Obsługa żądań XHR
	// ****************************************************************************************************
	abortAllActiveXhrRequests(){
		let that = this;

		if ( that.xhrActiveRequests.size > 0 ) {
			that.xhrActiveRequests.forEach( (xhrObj, key, map) => {
				xhrObj.abort();
				that.xhrActiveRequests.delete(key);
			});
		}
	}

	// ****************************************************************************************************
	// Pobieranie ceny historycznej
	// ****************************************************************************************************
	get30DaysPrice(id, curr, mode, country, priceNetto, priceBrutto, regularPriceNetto, regularPriceBrutto, promo_id, cont_id = null) {
		if ( cont_id === null ) {
			cont_id = id;
		}

		jQuery.ajax({
			url: "/info/ajax/30daysPrice/get30daysPrice.php?id="+id+"&curr="+curr+"&mode="+mode+"&country="+country+"&priceNetto="+(priceNetto*100)+"&priceBrutto="+(priceBrutto*100)+"&promo_id="+promo_id,
			type: 'GET',
			cache: false,
			contentType: false,
			processData: false,
		}).done(function(data){
			if ( data.includes("diagMode") ) {
				$("#last30days_"+cont_id).html(data.replace("diagMode", "")).removeClass("position-absolute");
			} else {
				if ( data.includes("regular") ) {
					if ( mode == "net")
						$("#last30days_"+cont_id).html(toolsObj.formatPrice(Number(data.replace("regular", regularPriceNetto))) + " " + NET_ADDON).removeClass("position-absolute");
					else
						$("#last30days_"+cont_id).html(toolsObj.formatPrice(Number(data.replace("regular", regularPriceBrutto))) + " " + GROSS_ADDON).removeClass("position-absolute");
				} else {
					if ( mode == "net")
						$("#last30days_"+cont_id).html(toolsObj.formatPrice(Number(data)/100) + " " + NET_ADDON).removeClass("position-absolute");
					else
						$("#last30days_"+cont_id).html(toolsObj.formatPrice(Number(data)/100) + " " + GROSS_ADDON).removeClass("position-absolute");
				}
			}
		}).fail(function(data){
			$("#last30days_"+cont_id).hide().html(data);
		}).always(function(data){
			if ( CFG_TEST && $("#last30daysGET_"+cont_id).length > 0 ) {
				$("#last30daysGET_"+cont_id).html("GET: ?id="+id+"&curr="+curr+"&mode="+mode+"&country="+country+"&priceNetto="+(priceNetto*100)+"&priceBrutto="+(priceBrutto*100)+"&promo_id="+promo_id);
				//$("#last30daysRES").html("RES:" + data.replace("diagMode", ""));
			}
		});
	}
}